export const sportColors = {
  futebol: '#ffffff',
  basket: '#FF9800',
  voleibol: '#ffffff',
  andebol: '#9C27B0',
  hoquei: '#ffffff',
  tenis: '#FFEB3B',
  futebolAmericano: '#795548',
  mma: '#DC143C',
  cs2: '#F59E0B',
  esports: '#8B5CF6',
  boxe: '#DC2626',
  futsal: '#2563EB',
  outros: '#6B7280',
};